/**
 * Converts Western Arabic numerals (1234567890) to Eastern Arabic numerals (٠١٢٣٤٥٦٧٨٩).
 * Eastern Arabic numerals are used in Arabic-speaking countries.
 *
 * Examples:
 * - 123 -> "١٢٣"
 * - 456789 -> "٤٥٦٧٨٩"
 * - "1.0" -> "١،٠"
 * - 12.75 -> "١٢،٧٥"
 *
 * @param value - The number or numeric string to convert
 * @returns The number formatted with Eastern Arabic numerals
 */
export default function formatInEasternArabicNumerals(
  value: number | string,
): string {
  const easternArabicNumerals = [
    "٠",
    "١",
    "٢",
    "٣",
    "٤",
    "٥",
    "٦",
    "٧",
    "٨",
    "٩",
  ];
  return String(value)
    .replace(/[.,]/g, "،")
    .replace(
      /[0-9]/g,
      (digit: string) => easternArabicNumerals[parseInt(digit, 10)],
    );
}
